export const MAP_STATE_NONE = 'mapStateNone';
export const MAP_STATE_VERTICAL = 'mapStateVertical';
export const MAP_STATE_HORIZONTAL = 'mapStateHorizontal';
